import { Axios } from "utils";

export const getSettingsById = async (key) => {
  const res = await Axios.get(`/Settings/${key}`);
  return res.data;
};
